// src/App.js
import React from 'react';

export default function App() {
  return (
    <>
    <h1>The site is under maintenance</h1>
    </>
  );
}
